module.exports = __webpack_public_path__ + "static/zwyzka-teleskopowa-helios-a7e70cacbefdb280e72004f76b08b05d.jpg";